// import { useState, useEffect, Suspense } from "react";
// import { useNavigate } from "react-router-dom";
// import { Canvas } from "@react-three/fiber";
// import { Environment, useGLTF, Html, OrbitControls } from "@react-three/drei";
// import {
//   Box,
//   Typography,
//   Button,
//   Card,
//   CardContent,
//   Container,
//   Grid,
//   Paper,
//   CircularProgress,
//   Stack,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
// } from "@mui/material";

// // MUI Icons
// import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
// import PsychologyAltOutlinedIcon from "@mui/icons-material/PsychologyAltOutlined";
// import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
// import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
// import VolumeOffOutlinedIcon from "@mui/icons-material/VolumeOffOutlined";
// import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
// import WifiOutlinedIcon from "@mui/icons-material/WifiOutlined";
// import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";

// // Local/Project-specific imports
// import Layout from "../common/Layout";
// import { initializeLipSync } from "./LipSyncService";
// import Avatar from "./Avatar";

// // --- Data Configuration for Assessment Sections ---
// const assessmentSections = {
//   communication: {
//     name: "Communication Skills",
//     icon: ForumOutlinedIcon,
//     description: "Evaluates your communication and interpersonal abilities.",
//   },
//   behavioral: {
//     name: "Behavioral Assessment",
//     icon: PsychologyAltOutlinedIcon,
//     description: "Assesses your responses to workplace scenarios.",
//   },
//   technical: {
//     name: "Technical Knowledge",
//     icon: SettingsOutlinedIcon,
//     description: "Tests your expertise and problem-solving skills.",
//   },
// };

// // --- NEW: Data for Instructions ---
// const instructionsList = [
//   {
//     icon: <LightbulbOutlinedIcon color="primary" />,
//     text: "Sit in a well-lit area where your face is clearly visible to the camera.",
//   },
//   {
//     icon: <VolumeOffOutlinedIcon color="primary" />,
//     text: "Ensure you are in a quiet environment to avoid any background noise or distractions.",
//   },
//   {
//     icon: <VideocamOutlinedIcon color="primary" />,
//     text: "Your camera and microphone must be enabled and working correctly throughout the assessment.",
//   },
//   {
//     icon: <WifiOutlinedIcon color="primary" />,
//     text: "A stable internet connection is required for a smooth and uninterrupted experience.",
//   },
//   {
//     icon: <GavelOutlinedIcon color="primary" />,
//     text: "Academic integrity is paramount. Any form of malpractice, cheating, or use of unauthorized aids is strictly prohibited and will lead to disqualification.",
//   },
// ];

// // --- 3D Model and Animation URLs ---
// const avatarUrl =
//   "https://models.readyplayer.me/686512bb52df6cb4f52b2fce.glb?morphTargets=Oculus%20Visemes&useMeshOptCompression=true&textureSizeLimit=512&textureQuality=medium";
// const idleAnimationUrl =
//   "https://readyplayerme-assets.s3.amazonaws.com/animations/male-idle-animation.glb";
// const talkingAnimationUrl = `${process.env.PUBLIC_URL}/assets/M_Talking_Variations_001.glb`;
// const environmentHdrUrl = `${process.env.PUBLIC_URL}/assets/studio_small_03_1k.hdr`;

// // --- Preload Assets ---
// useGLTF.preload(avatarUrl);
// useGLTF.preload(idleAnimationUrl);
// useGLTF.preload(talkingAnimationUrl);

// // --- Reusable Components ---
// const CanvasLoader = () => (
//   <Html center>
//     <CircularProgress color="primary" />
//   </Html>
// );

// const AssessmentSectionCard = ({ icon: Icon, title, description }) => (
//   <Paper
//     variant="outlined"
//     sx={{
//       bgcolor: "background.default",
//       p: 2.5,
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "space-between",
//       height: "100%",
//     }}
//   >
//     <Box>
//       <Typography variant="h6" color="primary" fontWeight="bold">
//         {title}
//       </Typography>
//       <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
//         {description}
//       </Typography>
//     </Box>
//     <Icon sx={{ fontSize: 56, color: "primary.main", ml: 2, opacity: 0.9 }} />
//   </Paper>
// );

// // --- Main Page Component ---
// const ExamIntroPage = () => {
//   const navigate = useNavigate();
//   const [isLipSyncReady, setIsLipSyncReady] = useState(false);
//   const [loadingMessage, setLoadingMessage] = useState(
//     "Initializing AI Voice Engine..."
//   );

//   useEffect(() => {
//     initializeLipSync()
//       .then(() => setIsLipSyncReady(true))
//       .catch((error) => {
//         console.error("LipSync Init Error:", error);
//         setLoadingMessage(
//           "Voice Engine Failed. Please refresh or try another browser."
//         );
//       });
//   }, []);

//   const handleStartExam = () => {
//     navigate("/gatep/talent/exam");
//   };

//   return (
//     <Layout title="AI Interview Assessment">
//       <Box sx={{ bgcolor: "background.default", py: { xs: 3, md: 6 } }}>
//         <Container maxWidth="lg">
//           {/* Top Header Card */}
//           <Paper
//             variant="outlined"
//             sx={{
//               bgcolor: "mint.main",
//               p: { xs: 2, md: 3 },
//             }}
//           >
//             <Typography
//               variant="h4"
//               component="h1"
//               color="primary"
//               fontWeight="bold"
//             >
//               AI Interview Assessment
//             </Typography>
//             <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
//               Experience the future of professional interviews.
//             </Typography>
//           </Paper>

//           {/* --- Main Content Card --- */}
//           <Paper
//             variant="outlined"
//             sx={{
//               bgcolor: "mint.main",
//               p: { xs: 2, md: 4 },
//               mt: 4,
//             }}
//           >
//             <Grid container spacing={{ xs: 3, md: 5 }} alignItems="center">
//               {/* Column 1: Assessment Sections */}
//               <Grid item xs={12} lg={7}>
//                 <Box>
//                   <Typography
//                     variant="h5"
//                     color="primary"
//                     fontWeight="bold"
//                     sx={{ mb: 3 }}
//                   >
//                     Assessment Sections
//                   </Typography>
//                   <Stack spacing={2.5}>
//                     {Object.values(assessmentSections).map((section) => (
//                       <AssessmentSectionCard
//                         key={section.name}
//                         icon={section.icon}
//                         title={section.name}
//                         description={section.description}
//                       />
//                     ))}
//                   </Stack>
//                 </Box>
//               </Grid>

//               {/* Column 2: Meet your AI Interviewer */}
//               <Grid item xs={12} lg={5}>
//                 <Card
//                   variant="outlined"
//                   sx={{
//                     bgcolor: "background.default",
//                     p: 2,
//                     width: "100%",
//                   }}
//                 >
//                   <CardContent>
//                     <Typography
//                       variant="h6"
//                       color="text.primary"
//                       fontWeight="600"
//                       textAlign="center"
//                       gutterBottom
//                     >
//                       Meet Your AI Interviewer
//                     </Typography>
//                     <Box
//                       sx={{
//                         height: "350px",
//                         bgcolor: "background.paper",
//                         borderRadius: 2,
//                         mt: 2,
//                         position: "relative",
//                         overflow: "hidden",
//                       }}
//                     >
//                       <Canvas camera={{ position: [0, 0, 8], fov: 45 }}>
//                         <Suspense fallback={<CanvasLoader />}>
//                           <ambientLight intensity={0.7} />
//                           <pointLight position={[10, 10, 10]} intensity={1} />
//                           <Avatar
//                             url={avatarUrl}
//                             idleAnimationUrl={idleAnimationUrl}
//                             talkingAnimationUrl={talkingAnimationUrl}
//                             isSpeaking={false}
//                             animationQueueRef={{ current: [] }}
//                           />
//                           <OrbitControls enableZoom={false} enablePan={false} />
//                           <Environment files={environmentHdrUrl} />
//                         </Suspense>
//                       </Canvas>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             </Grid>
//           </Paper>

//           {/* --- NEW: INSTRUCTIONS SECTION --- */}
//           <Paper
//             variant="outlined"
//             sx={{
//               bgcolor: "background.paper",
//               p: { xs: 2, md: 3 },
//               mt: 4,
//             }}
//           >
//             <Typography
//               variant="h5"
//               component="h2"
//               color="primary"
//               fontWeight="bold"
//               sx={{ mb: 2 }}
//             >
//               Before You Begin: Important Instructions
//             </Typography>
//             <List sx={{ pt: 0 }}>
//               {instructionsList.map((item, index) => (
//                 <ListItem key={index} disableGutters>
//                   <ListItemIcon sx={{ minWidth: "40px" }}>
//                     {item.icon}
//                   </ListItemIcon>
//                   <ListItemText
//                     primary={item.text}
//                     primaryTypographyProps={{ color: "text.secondary" }}
//                   />
//                 </ListItem>
//               ))}
//             </List>
//           </Paper>

//           {/* Start Button */}
//           <Box textAlign="center" sx={{ my: 5 }}>
//             <Button
//               variant="contained"
//               color="primary"
//               size="large"
//               onClick={handleStartExam}
//               disabled={!isLipSyncReady}
//               sx={{
//                 py: 1.5,
//                 px: 8,
//                 borderRadius: "50px",
//                 boxShadow: (theme) =>
//                   `0px 6px 15px ${theme.palette.primary.main}55`,
//                 fontSize: "1rem",
//               }}
//             >
//               {isLipSyncReady ? "BEGIN INTERVIEW" : loadingMessage}
//             </Button>
//           </Box>
//         </Container>
//       </Box>
//     </Layout>
//   );
// };

// export default ExamIntroPage;

import React, { useState, useEffect, useRef, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { Canvas } from "@react-three/fiber";
import { Environment, useGLTF, Html, OrbitControls } from "@react-three/drei";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Paper,
  CircularProgress,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

// MUI Icons
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import PsychologyAltOutlinedIcon from "@mui/icons-material/PsychologyAltOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import VolumeOffOutlinedIcon from "@mui/icons-material/VolumeOffOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import WifiOutlinedIcon from "@mui/icons-material/WifiOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";

// Local/Project-specific imports
import Layout from "../common/Layout";
import { initializeLipSync } from "./LipSyncService";
import Avatar from "./Avatar";

// --- Data Configuration for Assessment Sections ---
const assessmentSections = {
  communication: {
    name: "Communication Skills",
    icon: ForumOutlinedIcon,
    description: "Evaluates your communication and interpersonal abilities.",
  },
  behavioral: {
    name: "Behavioral Assessment",
    icon: PsychologyAltOutlinedIcon,
    description: "Assesses your responses to workplace scenarios.",
  },
  technical: {
    name: "Technical Knowledge",
    icon: SettingsOutlinedIcon,
    description: "Tests your expertise and problem-solving skills.",
  },
};

// --- NEW: Consolidated Instructions Data ---
const instructionsList = [
  {
    icon: <LightbulbOutlinedIcon />,
    text: "Sit in a well-lit area where your face is clearly visible.",
  },
  {
    icon: <VolumeOffOutlinedIcon />,
    text: "Find a quiet environment to avoid background noise.",
  },
  {
    icon: <VideocamOutlinedIcon />,
    text: "Ensure your camera and microphone are enabled and working.",
  },
  {
    icon: <WifiOutlinedIcon />,
    text: "A stable internet connection is required for a smooth experience.",
  },
  {
    icon: <GavelOutlinedIcon sx={{ color: "error.main" }} />,
    primaryText: "Academic Integrity is Mandatory",
    secondaryText:
      "Use of unauthorized aids is strictly prohibited and will result in disqualification.",
    isAlert: true,
  },
];

// --- 3D Model and Animation URLs ---
const avatarUrl = "https://models.readyplayer.me/686512bb52df6cb4f52b2fce.glb";
const idleAnimationUrl = `${process.env.PUBLIC_URL}/assets/male-idle-animation.glb`;
const talkingAnimationUrl = `${process.env.PUBLIC_URL}/assets/M_Talking_Variations_001.glb`;
const environmentHdrUrl = `${process.env.PUBLIC_URL}/assets/studio_small_03_1k.hdr`;

// --- Preload Assets ---
try {
  useGLTF.preload(avatarUrl);
  useGLTF.preload(idleAnimationUrl);
  useGLTF.preload(talkingAnimationUrl);
} catch (e) {
  console.error("Top-level preload failed", e);
}

// --- Reusable Components ---
const CanvasLoader = () => (
  <Html center>
    <CircularProgress color="primary" />
  </Html>
);

class ThreeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error("3D Render Error:", error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <Html center>
          <Box sx={{ textAlign: 'center', p: 2, bgcolor: 'rgba(255,255,255,0.8)', borderRadius: 2 }}>
            <Typography variant="body2" color="error" fontWeight="bold">
              3D Avatar failed to load.
            </Typography>
            <Button size="small" onClick={() => window.location.reload()} sx={{ mt: 1 }}>
              Retry
            </Button>
          </Box>
        </Html>
      );
    }
    return this.props.children;
  }
}

const AssessmentSectionCard = ({ icon: Icon, title, description }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        bgcolor: alpha(theme.palette.primary.main, 0.05),
        border: `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
        borderRadius: "16px",
        p: 2.5,
        display: "flex",
        alignItems: "center",
        height: "100%",
        transition: "all 0.25s ease",
        "&:hover": {
          border: `1px solid ${alpha(theme.palette.primary.main, 0.4)}`,
          bgcolor: alpha(theme.palette.primary.main, 0.08),
          transform: "translateY(-2px)",
        },
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle1" fontWeight={800} sx={{ color: "primary.main" }}>{title}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{description}</Typography>
      </Box>
      <Icon sx={{ fontSize: 48, color: alpha(theme.palette.primary.main, 0.5), ml: 2, flexShrink: 0 }} />
    </Box>
  );
};

// --- Main Page Component ---
const ExamIntroPage = () => {
  const navigate = useNavigate();
  const [isLipSyncReady, setIsLipSyncReady] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(
    "Initializing AI Voice Engine..."
  );
  const animationQueueRef = useRef([]);

  console.log("ExamIntroPage Rendering", { isLipSyncReady, loadingMessage });

  useEffect(() => {
    initializeLipSync()
      .then(() => setIsLipSyncReady(true))
      .catch((error) => {
        console.error("LipSync Init Error:", error);
        setLoadingMessage(
          "Voice Engine Failed. Please refresh or try another browser."
        );
      });
  }, []);

  const handleStartExam = () => {
    navigate("/db-shiksha/gatep/talent/exam");
  };

  return (
    <Layout title="AI Interview Assessment">
      <Box sx={{ bgcolor: "background.default", py: { xs: 4, md: 8 } }}>
        <Container maxWidth="lg">
          {/* 1. HEADER */}
          <Box sx={{ textAlign: "center", mb: 6 }}>
            <Typography
              variant="h3"
              component="h1"
              fontWeight={900}
              sx={{
                background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${alpha(theme.palette.primary.main, 0.6)} 100%)`,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                letterSpacing: "-1px",
              }}
            >
              AI Interview Assessment
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ mt: 1, fontWeight: 400 }}>
              You are about to begin your automated interview.
            </Typography>
          </Box>

          {/* 2. MAIN CONTENT (AVATAR & SECTIONS) */}
          <Box
            sx={{
              bgcolor: "background.paper",
              border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
              borderRadius: "24px",
              p: { xs: 2.5, md: 4 },
              backdropFilter: "blur(12px)",
            }}
          >
            <Grid container spacing={{ xs: 4, md: 5 }} alignItems="stretch">
              <Grid item xs={12} lg={5}>
                <Box
                  sx={{
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
                    border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
                    borderRadius: "20px",
                    p: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                    <Typography
                      variant="subtitle1"
                      fontWeight={800}
                      textAlign="center"
                      sx={{ color: "primary.main", letterSpacing: "0.05em", textTransform: "uppercase", fontSize: "0.78rem", mb: 2 }}
                    >
                      Meet Your AI Interviewer
                    </Typography>
                    <Box
                      sx={{
                        flexGrow: 1,
                        minHeight: "350px",
                        bgcolor: (theme) => alpha(theme.palette.common.black, 0.3),
                        borderRadius: "16px",
                        position: "relative",
                        overflow: "hidden",
                        border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                      }}
                    >
                      <Canvas camera={{ position: [0, 0, 8], fov: 45 }}>
                        <Suspense fallback={<CanvasLoader />}>
                          <ambientLight intensity={0.7} />
                          <pointLight position={[10, 10, 10]} intensity={1} />
                          <ThreeErrorBoundary>
                            <Avatar
                              url={avatarUrl}
                              idleAnimationUrl={idleAnimationUrl}
                              talkingAnimationUrl={talkingAnimationUrl}
                              isSpeaking={false}
                              animationQueueRef={animationQueueRef}
                            />
                          </ThreeErrorBoundary>
                          <OrbitControls enableZoom={false} enablePan={false} />
                          <Environment files={environmentHdrUrl} />
                        </Suspense>
                      </Canvas>
                    </Box>
                </Box>
              </Grid>

              <Grid item xs={12} lg={7}>
                <Typography
                  variant="subtitle1"
                  fontWeight={800}
                  sx={{ mb: 3, color: "primary.main", letterSpacing: "0.06em", textTransform: "uppercase", fontSize: "0.78rem" }}
                >
                  This assessment will cover:
                </Typography>
                <Stack spacing={2.5}>
                  {Object.values(assessmentSections).map((section) => (
                    <AssessmentSectionCard
                      key={section.name}
                      icon={section.icon}
                      title={section.name}
                      description={section.description}
                    />
                  ))}
                </Stack>
              </Grid>
            </Grid>
          </Box>

          {/* 3. INSTRUCTIONS & GUIDELINES */}
          <Box
            sx={{
              bgcolor: "background.paper",
              border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
              borderRadius: "24px",
              p: { xs: 2.5, md: 4 },
              mt: 4,
            }}
          >
            <Typography
              variant="subtitle1"
              fontWeight={800}
              sx={{ mb: 3, color: "primary.main", letterSpacing: "0.06em", textTransform: "uppercase", fontSize: "0.78rem" }}
            >
              Instructions & Guidelines
            </Typography>
            <List sx={{ mt: 0, p: 0 }}>
              {instructionsList.map((item, index) => (
                <Box key={index}>
                  <ListItem sx={{ py: 1.5, px: 0 }}>
                    <ListItemIcon
                      sx={{
                        minWidth: 52,
                        "& .MuiSvgIcon-root": {
                          color: item.isAlert ? "error.main" : "primary.main",
                          fontSize: 24,
                        },
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.primaryText || item.text}
                      secondary={item.secondaryText}
                      primaryTypographyProps={{
                        fontWeight: item.isAlert ? 800 : 600,
                        color: item.isAlert ? "error.main" : "text.primary",
                        variant: "body2",
                      }}
                      secondaryTypographyProps={{ color: "text.secondary", variant: "caption" }}
                    />
                  </ListItem>
                  {index < instructionsList.length - 1 && (
                    <Divider component="li" sx={{ borderColor: (theme) => alpha(theme.palette.primary.main, 0.08) }} />
                  )}
                </Box>
              ))}
            </List>
          </Box>

          {/* 4. CALL TO ACTION */}
          <Box textAlign="center" sx={{ my: 6 }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleStartExam}
              disabled={!isLipSyncReady}
              sx={{
                py: 2,
                px: 8,
                borderRadius: "50px",
                fontSize: "1.1rem",
                fontWeight: 900,
                letterSpacing: "0.06em",
                textTransform: "uppercase",
                boxShadow: (theme) => `0px 8px 30px ${alpha(theme.palette.primary.main, 0.35)}`,
                "&:hover": {
                  boxShadow: (theme) => `0px 12px 40px ${alpha(theme.palette.primary.main, 0.5)}`,
                  transform: "translateY(-2px)",
                },
                transition: "all 0.25s ease",
              }}
            >
              {isLipSyncReady ? "BEGIN INTERVIEW" : loadingMessage}
            </Button>
          </Box>
        </Container>
      </Box>
    </Layout>
  );
};

export default ExamIntroPage;
